import React, {useState} from 'react'
import { IoSearch } from 'react-icons/io5'
import _ from 'lodash';
const ABC = [
  {
    ABCD: 'Abatar',
  },
  {
    ABCD: 'Titanic'
  },
  {
    ABCD: 'Star Wars: The Force Awakens'
  }
]
function PQR(x1, x2) {
  return x1.filter(x => 
    x.ABCD.toLowerCase().includes(x2.toLowerCase())
  )
}
const GHI = ({x}) => {
  return (<div className='text-xs'>{x.ABCD}<br/></div>)
}
export default function DEF() {
  const [JKL, setJKL] = useState(ABC)
  const [MNO, setMNO] = useState('')
  const STU = e => {
    setMNO(e.target.value)
    const VWX = PQR(ABC, e.target.value)
    setJKL(VWX)
  }
  return (
    <>
      <div className='flex'><IoSearch className='mt-auto mb-auto text-[12px]'/><input type='text' value={MNO} onChange={STU} className='border border-gray-950 ml-[1px] text-[9px]'/></div>
      {
        JKL.map(x => <GHI x={x}/>)
      }
  </>
  )
}